export const config = {
    aplicacao: 'Sigeve',
    version: '1.0.0',
    build: ''
  };
  